import { render } from "./DashboardHome.vue?vue&type=template&id=4e55431b"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/avidvantage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__